import { render } from "./TableGlobalSearch.vue?vue&type=template&id=3039bbd0"
import script from "./TableGlobalSearch.vue?vue&type=script&lang=js"
export * from "./TableGlobalSearch.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app.rizome-bxl.be/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__